document.addEventListener('DOMContentLoaded', () => {
  const fix = (el) => {
    if (!el) return;

    el.min = 6;
    el.step = 6;
    if (!el.value || Number(el.value) < 6) el.value = 6;

    el.addEventListener('change', () => {
      let v = parseInt(el.value || '6', 10);
      if (isNaN(v) || v < 6) v = 6;

      // Round to the nearest multiple of 6
      v = Math.round(v / 6) * 6;
      if (v < 6) v = 6;
      el.value = v;
    });
  };

  // Apply rule on product pages
  document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]').forEach(fix);

  // Reapply when bundle or variant reloads dynamically
  const obs = new MutationObserver(() => {
    document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]').forEach(fix);
  });

  obs.observe(document.body, { childList: true, subtree: true });
});
